import { GridColDef } from "@mui/x-data-grid";
import { reduce } from "et3-type-guards";

export const escapeTextStringParsing = (text: string) => {
  const parsedText = text.replace(/["']/g, (char: string) => {
    switch (char) {
      case '"':
        return "“";
      case "'":
        return "‘";
      default:
        return "";
    }
  });
  return parsedText;
};

export const exportToCSV = <T>(data: T[], columns: GridColDef[]) => {
  if (data.length === 0 || columns.length === 0) {
    return;
  }

  const headers = columns.map((col) => col.headerName || col.field);
  const fields = columns.map((col) => col.field);

  const rows = data.map((row) => {
    return fields.map((field) => {
      const value = (row as any)[field];
      return JSON.stringify(reduce(() => value, ""));
    });
  });

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.join(","))
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "data.csv");
  link.click();
  URL.revokeObjectURL(url);
};
